/**
 * Return the file extension from the complete filename
 * @param {String} fname file name
 */
export const getFileExtension = fname => fname.slice(((fname.lastIndexOf('.') - 1) >>> 0) + 2);



// WEBPACK FOOTER //
// ./src/utils/fileUtils.js